/* global require */
window._ = require("lodash");
import axios from "axios";
import Store from "./store/index";
import { base_url } from "./configs/app.js";

const BASE_URL = base_url;

axios.defaults.withCredentials = true;

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
    console.error(
        "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
    );
}

axios.interceptors.response.use(
    (success) => {
        Store.dispatch("overlay/turnOff");
        return success;
    },
    (error) => {
        Store.dispatch("overlay/turnOff");
        Store.dispatch("errors/catch", error);
        return Promise.reject(error);
    }
);
axios.interceptors.request.use((config) => {
    config.url = BASE_URL + config.url;
    Store.dispatch("validation/reset");
    Store.dispatch("overlay/turnOn");
    return config;
});

window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
